import { ToggleGroup, ToggleGroupItem, Tooltip } from "@motleyhand/design"
import type { ComponentProps, ReactNode } from "react"
import FormControl from "./FormControl"

type Props = ComponentProps<typeof ToggleGroup> & {
  name: string
  options: {
    label: ReactNode
    value: string
    tooltip?: string
  }[]
}

export default function FormToggleButton({
  name,
  options,
  onValueChange,
  ...rest
}: Props) {
  return (
    <FormControl name={name} required>
      {({ field: { onChange, ...restField } }) => {
        const handleChange = (
          ...args: Parameters<NonNullable<typeof onValueChange>>
        ) => {
          onChange(args[0][0])
          onValueChange?.(...args)
        }

        return (
          <ToggleGroup
            onValueChange={handleChange}
            {...restField}
            {...rest}
            multiple={false}
          >
            {options.map(({ label, value, tooltip }) => (
              <Tooltip
                key={value}
                tooltip={tooltip}
                side={rest.orientation === "vertical" ? "right" : "top"}
              >
                <ToggleGroupItem value={value}>{label}</ToggleGroupItem>
              </Tooltip>
            ))}
          </ToggleGroup>
        )
      }}
    </FormControl>
  )
}
